//Required Module imports//
import React, { Component } from 'react';
import { Button, Popconfirm, Input } from 'antd';
import {
  DeleteOutlined,
  EditOutlined,
  QuestionCircleOutlined,
  SearchOutlined
} from '@ant-design/icons';
//Required Component imports//
import {
  //  getMasterById,
  getMasterList,
  deleteMaster,
  getUsersList
} from '../../../Utils/FormCalls';
//css//
import Highlighter from 'react-highlight-words';
import { constant } from '../../../Utils/constants';
import { StyledComponent } from '../../../CSS/style';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getUserProfile } from '../../../../../selectors/layout';
import { getTranslationCache } from '../../../../../selectors/language';
import translation from '../../../Utils/translation';
import themeSettings from '../../../Utils/themeSettings.json';
import ListView from '../../../Utils/ListView';
import history from '../../../../../commons/history';
import { encode as base64_encode } from 'base-64';
import Tooltip from 'antd/es/tooltip';
import { API_MASTERTOOL } from '../../../../../commons/api';

const urlList = {
  list: API_MASTERTOOL.LIST,
  delete: API_MASTERTOOL.DELETE
};

class ToolsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
      activeKey: '1',
      form: {},
      searchText: '',
      translationCache: props.translationCache || [],
      userProfile: props && props.userProfile ? props.userProfile : {},
      userList: [],
      config: {
        viewTypes: ['add', 'card', 'table'],
        defaultViewType: 'table',

        filterType: 'ByAttributeValue',
        attributeList: ['Tool'],

        firstTitle: 'Tool',
        secondTitle: 'CreatedBy',
        thirdTitle: 'CreatedTime',

        actions: ['edit', 'delete'],
        edit: {
          byAttribute: 'Id',
          redirectURL: '/rubus/AMM/ToolsDetails'
        },
        deletee: {
          byAttribute: 'Id'
        }
      }
    };
  }
  searchInput = React.createRef();
  componentDidUpdate(prevprops) {
    if (prevprops.translationCache !== this.props.translationCache) {
      this.setState({
        translationCache: this.props.translationCache
      });
    }
    if (this.props.match.params.Masters !== prevprops.match.params.Masters) {
      let mastername = this.props.match.params.Masters;
      this._getAdhocDataSource();
      this.setState({ mastername });
    }
  }
  componentDidMount = async () => {
    this._getAdhocDataSource();
  };
  _getUserList = async () => {
    let userList = await getUsersList();
    this.setState({ userList });
  };
  _getAdhocDataSource = async () => {
    let dataSource = await getMasterList(urlList.list);
    this.setState({
      dataSource,
      activeKey: '1',
      form: {}
    });
  };

  downTimeData = (form) => {
    this.setState({
      form
    });
  };
  _editRecord = async (record) => {
    let { config } = this.state;
    history.push({ pathname: `${config.edit.redirectURL}/${base64_encode(record.Id)}` });
  };
  _deleteById = async (id) => {
    await deleteMaster(urlList.delete, id);
    let dataSource = await getMasterList(urlList.list);
    this.setState({
      dataSource
    });
  };
  // deleteToolMaster = async (record) => {
  //   await deleteMaster(urlList.delete, record.Id);
  //   let dataSource = await getMasterList(urlList.list);
  //   this.setState({
  //     dataSource,
  //     activeKey: '1'
  //     // form: {}
  //   });
  // };

  // editMaster = async (tableRowData) => {
  //   let { form } = this.state;
  //   let data = await getMasterById(urlList.getbyId, tableRowData.Id, method.Method);
  //   form = {
  //     ...data
  //   };
  //   // let datasource = data.Specifications[0]
  //   this.setState({
  //     activeKey: '2',
  //     form
  //     // datasource: data.Specifications
  //   });
  // };
  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={translation(this.props.translationCache, `Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(this.props.translationCache, constant.search)}
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters, confirm)}
          size="small"
          style={{ width: 90 }}
        >
          {translation(this.props.translationCache, constant.reset)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, fontSize: '130%' }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };
  handleReset = (clearFilters, confirm) => {
    clearFilters();
    this.handleSearch([], confirm);
  };

  render() {
    const { dataSource, userList } = this.state;
    let { translationCache } = this.props;

    let columns = [
      {
        title: translation(translationCache, constant.tool),
        dataIndex: 'Tool',
        key: 'Tool',
        filter: true,
        ...this.getColumnSearchProps('Tool')
      },
      {
        title: translation(translationCache, constant.description),
        dataIndex: 'Description',
        key: 'Description',
        ...this.getColumnSearchProps('Description')
      },
      {
        title: translation(translationCache, constant.storeLocation),
        dataIndex: 'StoreLocation',
        key: 'StoreLocation',
        filter: true
      },
      {
        title: translation(translationCache, constant.action),
        width: '600',
        render: (text, record) => (
          <>
            <Button className="ant-btn" onClick={() => this._editRecord(record)} size="middle">
              <Tooltip title={translation(translationCache, 'Edit')}>
                <EditOutlined />
              </Tooltip>
            </Button>
            <Popconfirm
              title={translation(translationCache, constant.deleteToolMaster)}
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
              onConfirm={() => this._deleteById(record.Id)}
              okText={translation(translationCache, constant.yes)}
              cancelText={translation(translationCache, constant.no)}
            >
              <Button className="ant-btn" size="middle">
                <span style={{ color: '#ff4d4f' }}>
                  {' '}
                  <Tooltip title={translation(translationCache, 'Delete')}>
                    <DeleteOutlined />
                  </Tooltip>
                </span>
              </Button>
            </Popconfirm>
          </>
        )
      }
    ];
    let config = {
      title: translation(translationCache, 'Tool'),

      viewTypes: ['add', 'card', 'table'],
      defaultViewType: 'table',

      filterType: 'ByAttributeValue',
      attributeList: ['Tool'],

      firstTitle: 'Tool',
      secondTitle: 'CreatedBy',
      thirdTitle: 'CreatedTime',

      actions: ['edit', 'delete'],
      edit: {
        byAttribute: 'Id',
        redirectURL: '/rubus/AMM/ToolsDetails'
      },
      deletee: {
        byAttribute: 'Id'
      }
    };

    return (
      <StyledComponent theme={themeSettings} style={{ minHeight: window.innerHeight - 143 }}>
        <ListView
          columns={columns}
          dataSource={dataSource}
          userList={userList}
          config={config}
          delete={this._deleteById}
        />
      </StyledComponent>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  userProfile: getUserProfile(),
  translationCache: getTranslationCache()
});
export default connect(mapStateToProps)(ToolsList);
